import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import {reducer as toastrReducer} from 'react-redux-toastr'
import states from './states/index'

const reducerMaker = () => {
  return {
    ...states,
    toastr: toastrReducer,
    loadingBar: loadingBarReducer,
    routing: routerReducer
  }
}

export default combineReducers(reducerMaker())



// WEBPACK FOOTER //
// ./src/rootReducer.js